module.exports = __webpack_public_path__ + "02_short_brown.73cabaa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_short_brown.png
// module id = NSIk
// module chunks = 0